import { clone } from 'lodash';

export const getTranslationData = (lang, val) => {

    const i18n = {
        "es_ES" : { // spanish lang
          "Viewnow": "Conoce más",
          "By": "Por",
          "Medicallyreviewedby": "Revisado Por",
          "Writtenby": "Escrito por",
          "WebMDEditorialContributors": "Colaboradores editoriales de WebMD",
          "WebMDEditorialContributor": "Colaborador editorial de WebMD",
          "January": "enero",
          "February": "febrero",
          "March": "marzo",
          "April": "abril",
          "May": "mayo",
          "June": "junio",
          "July": "julio",
          "August": "agosto",
          "September": "septiembre",
          "October": "octubre",
          "November": "noviembre",
          "December": "diciembre",          
        }
    };

    if (lang) {
      const copyLangStr = clone(val);
      if (lang && i18n[lang]) {
        // remove white spache from str value
        return i18n[lang][copyLangStr.replace(/\s/g, '')] || val;
      } else return val;
    }

    return val;
};
